/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/control-has-associated-label */
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import CustomDatePicker from '@shared/customComponents/CustomDatePicker/CustomDatePicker';
import { addMedications } from '@/app/services/students/students';
import { CircularProgress, FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core/';
import { DeleteRounded } from '@material-ui/icons';
import { Fragment, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as Actions from '@/app/store/actions';
import { useNavigate, useLocation } from 'react-router-dom';
import dayjs from 'dayjs';
import PageHeader from '@/app/customComponents/PageHeader';

const EditMedications = () => {
	const location = useLocation();
	const token = location?.state?.token;
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [isSaving, setIsSaving] = useState(false);

	useEffect(() => {
		if (!location?.state?.student) {
			navigate(-1);
		}
	}, [location?.state?.student]);

	const { student } = location?.state;

	const [modifiedStudent, setModifiedStudent] = useState({
		...student,
		doctor: student?.doctor?.name,
	});
	const [modifiedMedications, setModifiedMedications] = useState(student?.medications ? [...student.medications] : []);
	const [errTxts, setErrTxts] = useState({});

	const handleSubmit = () => {
		const medicationData = {
			doctor_name: modifiedStudent.doctor,
			allergies: modifiedStudent.allergies,
			is_medical_condition: modifiedStudent.is_medical_condition || 0,
			student_id: student.id,
			medication_data: modifiedMedications,
			description: modifiedStudent.description,
		};
		let isError = false;
		modifiedMedications.forEach((med, i) => {
			if (!med.name) {
				isError = true;
				setErrTxts((prevState) => ({ ...prevState, [`med.${i}.name`]: 'This field is required' }));
			}
			if (!med.frequency) {
				isError = true;
				setErrTxts((prevState) => ({ ...prevState, [`med.${i}.frequency`]: 'This field is required' }));
			}
			if (!med.start_date) {
				isError = true;
				setErrTxts((prevState) => ({ ...prevState, [`med.${i}.start_date`]: 'This field is required' }));
			}
			if (!med.end_date) {
				isError = true;
				setErrTxts((prevState) => ({ ...prevState, [`med.${i}.end_date`]: 'This field is required' }));
			}
		});
		if (isError) {
			return;
		}
		setIsSaving(true);
		addMedications(medicationData)
			.then((resp) => {
				dispatch(
					Actions.showMessage({
						message: resp.data.message,
						variant: 'success',
					})
				);
				setIsSaving(false);
				if (token) {
					navigate(`studentform?token=${token}`, { tab: 'medication' });
				} else {
					navigate(`students-student/${student.id}`, { tab: 'medication' });
				}
			})
			.catch((err) => {
				dispatch(
					Actions.showMessage({
						message: err?.response?.data?.message || 'Failed to Update Medications',
						variant: 'error',
					})
				);
				setIsSaving(false);
			});
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		setErrTxts({ ...errTxts, [name]: '' });
		if (name === 'is_medical_condition' && value === 0) {
			setModifiedStudent({ ...modifiedStudent, [name]: value, description: '' });
			return;
		}
		setModifiedStudent({ ...modifiedStudent, [name]: value });
	};

	const handleMedicationChange = (e, index) => {
		const { name, value } = e.target;
		setErrTxts({ ...errTxts, [`med.${index}.${name}`]: '' });
		const temp = { ...modifiedMedications[index], [name]: value };
		setModifiedMedications([...modifiedMedications.slice(0, index), temp, ...modifiedMedications.slice(index + 1)]);
	};

	const setStartDate = (date, index) => {
		delete errTxts[`med.${index}.start_date`];
		const temp = { ...modifiedMedications[index], start_date: date ? dayjs(date).format('YYYY-MM-DD') : '' };
		setModifiedMedications([...modifiedMedications.slice(0, index), temp, ...modifiedMedications.slice(index + 1)]);
	};
	const setEndDate = (date, index) => {
		delete errTxts[`med.${index}.end_date`];
		const temp = { ...modifiedMedications[index], end_date: date ? dayjs(date).format('YYYY-MM-DD') : '' };
		setModifiedMedications([...modifiedMedications.slice(0, index), temp, ...modifiedMedications.slice(index + 1)]);
	};

	const addMedication = () => {
		setModifiedMedications([...modifiedMedications, { name: '', frequency: '', start_date: '', end_date: '' }]);
	};

	const removeMedication = (index) => {
		setErrTxts({});
		const temp = [...modifiedMedications.slice(0, index), ...modifiedMedications.slice(index + 1)];
		setModifiedMedications(temp);
	};

	const handleGoBack = () => {
		if (token) {
			navigate(`studentform?token=${token}`, { tab: 'medication' });
		} else {
			navigate(`students-student/${student.id}`, { tab: 'medication' });
		}
	};
	return (
		<div className="P-m w-11/12 sm:9/10 mx-auto">
			<div className="stdinfo flex items-center flex-nowrap justify-between mx-auto">
				<span className="personal-hd info-hd stext-pd-2xl self-end font-extrabold ">
					<PageHeader onBack={handleGoBack} title="Edit Medical" />
				</span>
			</div>
			<div className="bg-white pb-24 mb-64 mx-auto">
				<div className=" p-8 sm:p-16 md:p-32 bg-white mx-auto">
					<div className="flex justify-between width-30-fields flex-wrap sm:gap-12">
						<TextField
							className="my-16 sm:my-0"
							error={!!errTxts.allergies}
							helperText={errTxts.allergies}
							label="Allergies"
							name="allergies"
							onChange={handleChange}
							value={modifiedStudent.allergies || ''}
						/>
						<TextField
							className="mb-16 sm:mb-0"
							error={!!errTxts.doctor}
							helperText={errTxts.doctor}
							label="Doctor"
							name="doctor"
							onChange={handleChange}
							value={modifiedStudent.doctor || ''}
						/>
						<FormControl className="" variant="standard">
							<InputLabel id="relationLabel">Medical Condition</InputLabel>
							<Select
								className="mb-16 sm:mb-0"
								defaultValue={modifiedStudent.is_medical_condition || 0}
								id="medical-condition"
								label="Medical Condtion"
								labelId="relationLabel"
								name="is_medical_condition"
								onChange={handleChange}
							>
								<MenuItem value={1}>Yes</MenuItem>
								<MenuItem value={0}>No</MenuItem>
							</Select>
						</FormControl>
					</div>
					{modifiedStudent.is_medical_condition === 1 ? (
						<div className="mt-12">
							<TextField
								className="w-full mb-16 sm:mb-0"
								error={errTxts.description}
								helperText={errTxts.description}
								label="Description"
								name="description"
								onChange={handleChange}
								value={modifiedStudent.description || ''}
							/>
						</div>
					) : (
						''
					)}
					<hr className="mt-32" style={{ color: 'lightgrey' }} />
					<div className="mt-20 text-pd-xxs sm:text-pd-base">
						<div className="bg-blue-100 px-0 md:px-40 py-12 flex justify-around gap-12">
							<div className="font-bold med-table-headers w-3/12">Medication</div>
							<div className="font-bold med-table-headers w-3/12">Frequency</div>
							<div className="font-bold med-table-headers w-3/12">Start Date</div>
							<div className="font-bold med-table-headers w-3/12">End Date</div>
							<div />
						</div>
						{modifiedStudent.is_medical_condition === 1 ? (
							(modifiedMedications?.length &&
								modifiedMedications?.map((medication, index) => {
									return (
										<Fragment key={medication.id}>
											<div className="mt-10 px-0 md:px-40 py-12 flex items-end justify-around gap-12">
												<div className="w-3/12">
													<TextField
														error={errTxts[`med.${index}.name`]}
														helperText={errTxts[`med.${index}.name`]}
														label="Medication"
														name="name"
														onChange={(e) => handleMedicationChange(e, index)}
														required
														value={medication.name}
													/>
												</div>
												<div className="w-3/12">
													<TextField
														error={errTxts[`med.${index}.frequency`]}
														helperText={errTxts[`med.${index}.frequency`]}
														label="Frequency"
														name="frequency"
														onChange={(e) => handleMedicationChange(e, index)}
														required
														value={medication.frequency}
													/>
												</div>
												<div className="w-3/12">
													<CustomDatePicker
														disablePast
														errTxts={errTxts[`med.${index}.start_date`]}
														label="Start Date"
														maxDate={modifiedMedications[index].end_date}
														required
														setValue={(date) => setStartDate(date, index)}
														value={medication.start_date}
														width="90%"
													/>
												</div>
												<div className="w-3/12">
													<CustomDatePicker
														errTxts={errTxts[`med.${index}.end_date`]}
														label="End Date"
														minDate={modifiedMedications[index].start_date}
														required
														setValue={(date) => setEndDate(date, index)}
														value={medication.end_date}
														width="90%"
													/>
												</div>
												<div
													className="cursor-pointer"
													onClick={() => removeMedication(index)}
													style={{ color: '#42B2E9', padding: 1 }}
												>
													<DeleteRounded />
												</div>
											</div>
											<hr className="mt-10" style={{ color: 'lightgrey' }} />
										</Fragment>
									);
								})) || (
								<>
									<div className="flex justify-center mt-20 font-bold text-pd-lg">No Medication</div>
									<hr className="mt-10" style={{ color: 'lightgrey' }} />
								</>
							)
						) : (
							<>
								<div className="flex justify-center mt-20 font-bold text-pd-lg">No Medical Condition</div>
								<hr className="mt-10" style={{ color: 'lightgrey' }} />
							</>
						)}
						{modifiedStudent.is_medical_condition === 1 ? (
							<>
								<div className="mt-10 px-40 py-12 flex justify-around">
									<div className="flex cursor-pointer items-center justify-start w-full gap-10" onClick={addMedication}>
										<img alt="" src="assets/images/add-med.png" style={{ width: 40 }} /> + Add Medication
									</div>
								</div>
								<hr className="mt-10" style={{ color: 'lightgrey' }} />
							</>
						) : (
							''
						)}
					</div>
				</div>
				<div className="btnedit">
					{!isSaving ? (
						<div className=" center-btn">
							<CustomButton
								onClick={() => {
									if (token) {
										navigate(`studentform?token=${token}`, { tab: 'medication' });
									} else {
										navigate(`students-student/${student.id}`, { tab: 'medication' });
									}
								}}
								variant="secondary"
							>
								Cancel
							</CustomButton>
							<CustomButton onClick={handleSubmit} variant="primary">
								Update
							</CustomButton>
						</div>
					) : (
						<div className="flex justify-center">
							<CircularProgress className="mx-auto" />
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default EditMedications;
